import { Icon } from '@openeducation/oe-rn-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import FeedbackResponse from './feedback-response';
import { Colors } from '../../../colors';
import { Button } from '../../../components/button/button';
import { useColors } from '../../../hooks';

export default function FeedbackSuccess({
  onClose,
  onReset,
  newQuestionKey,
  children,
}) {
  const colors = useColors();
  const { t } = useTranslation();

  return (
    <FeedbackResponse
      icon={() => (
        <Icon type="solid" name="check" size={40} color={Colors.primary} />
      )}
      onClose={onClose}
    >
      {children}

      {newQuestionKey && (
        <Button
          textStyle={[
            styles.lowProfileButtonText,
            {
              color: colors.oeAppSecondary,
              backgroundColor: colors.transparent,
            },
          ]}
          containerStyle={[
            styles.lowProfileButtonContainer,
            {
              backgroundColor: colors.transparent,
            },
          ]}
          onPress={onReset}
        >
          {t(newQuestionKey)} »
        </Button>
      )}
    </FeedbackResponse>
  );
}

const styles = StyleSheet.create({
  lowProfileButtonContainer: {
    marginTop: 25,
  },
  lowProfileButtonText: {
    fontWeight: 'normal',
    fontSize: 16,
  },
});
